import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Filter, Header } from './component';
import { DataTable, Excel } from 'CommonComponent';
import { useNavigate } from 'react-router-dom';
import { fetchJobLogs } from 'pages/ACD/actions/JobLogsActions';
import moment from 'moment';

const ActionCell = ({ row }) => {
  const navigate = useNavigate();
  return (
    <img
      src="/assets/images/view-icon.svg"
      alt="View"
      style={{ width: 20, height: 20, cursor: 'pointer' }}
      onClick={() => navigate(`/acd-job-logs/view/${row.id}`)}
      title="View"
    />
  );
};

const columns = [
  { id: "integration_name", header: "Integration Name", accessor: row => row.integration_name, sortable: true, searchable: true },
  { id: "integration_type", header: "Integration Type", accessor: row => row.integration_type, sortable: true, searchable: true },
  { id: "run_datetime", header: "Run Datetime", accessor: row => moment(row.run_datetime).format('YYYY-MM-DD HH:mm:ss'), sortable: true },
  { id: "status", header: "Status", accessor: row => row.status, sortable: true, searchable: true },
  { id: "success_requests", header: "Success Sub Requests", accessor: row => row.success_requests, sortable: true },
  { id: "error_requests", header: "Error Sub Requests", accessor: row => row.error_requests, sortable: true },
  {
    id: "action",
    header: "Action",
    accessor: row => <ActionCell row={row} />,
    sortable: false,
    searchable: false,
  },
];

const Logs = () => {
  const dispatch = useDispatch();
  
  const acdReportState = useSelector(state => state.acdReportState);
  const session = useSelector(state => state.session);
  const object_viewed_id = session?.current_page_permissions?.object_id || "";

  const [extraFiltersState, setExtraFiltersState] = useState({
    values: {},
  });

  /*useEffect(() => {
     if (object_viewed_id) {
         dispatch(fetchJobLogs({ ...extraFiltersState.values, object_viewed_id }));
     }
  }, [extraFiltersState.values, object_viewed_id]);*/

  const handleFilter = () => {
    dispatch(fetchJobLogs({ ...extraFiltersState.values, object_viewed_id }));
  };

  const handleClear = () => {
    setExtraFiltersState({ values: {} });
    dispatch(fetchJobLogs({ object_viewed_id }));
  }

  const { jobLogs } = acdReportState;

  return (
    <div className='wrapper-div'>
      <Header />
      {/*<div className="d-flex align-items-center justify-content-end gap-3 px-4 mb-3">
        <Excel />
      </div>*/}
      <Filter 
        onFilter={handleFilter} 
        onClear={handleClear} 
        extraFiltersState={extraFiltersState} 
        setExtraFiltersState={setExtraFiltersState} 
      />
      <DataTable
        columns={columns}
        data={jobLogs?.data || []}
        loading={jobLogs?.loading}
        serverSide={false}
        showSearch={false}
        className='table-container'
        defaultSortField="run_datetime"
        defaultSortAsc={false}
      />
    </div>
  )
}

export default Logs